"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawingBaseSchema = exports.DrawingNetPointerSchema = void 0;
const zod_1 = require("zod");
const ColorOverride_1 = require("./ColorOverride");
exports.DrawingNetPointerSchema = zod_1.z.object({
    i: zod_1.z.string(),
    n: zod_1.z.string(),
});
exports.DrawingBaseSchema = zod_1.z.object({
    type: zod_1.z.string(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.union([zod_1.z.string(), zod_1.z.number(), zod_1.z.boolean()])).optional(),
    net: zod_1.z.string().optional(),
    nets: exports.DrawingNetPointerSchema.array().optional(),
    colorOverride: ColorOverride_1.ColorOverrideSchema.optional(),
});
//# sourceMappingURL=DrawingBase.js.map